module.exports = __webpack_public_path__ + "img/logo_entreprendre_wapi.6204a99d.png";